var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"App"},[_c('full'),_c('toTop'),_c('div',{staticClass:"root"},[_c('headerList',{attrs:{"nav-data":_vm.navData}})],1),_c('RouterView'),_c('bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }